import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Dragon Flame — serpentine fire dragon form.
 * heart3D + spiral3D for head/body, exponential3D for
 * flaming breath, and swirl3D for coiling body.
 */
export const example39 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Dragon Flame',
    description:
      'serpentine fire dragon form. heart3D + spiral3D for head/body, exponential3D for flaming breath, and swirl3D for coiling body.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -2.5,
    skipIters: 22,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitBall',
    vibrancy: 1.5,
    contrast: 5.0,
    gamma: 3.5,
    depthColorPower: 0.0,
    lightDirection: [0.7, 0, -0.7],
    lightPower: 0.1,
    highlightPower: 1.2,
    densityEstimationQuality: 0.65,
    estimatorCurve: 0.4,
    paletteMode: 0,
    palettePhase: 0.1,
    paletteSpeed: 0.55,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 5.5,
      phi: 1.6,
      radius: 2.0,
      target: [0, 0, 0],
      fov: 55,
    },
  },
  transforms: {
    [tid('3d_dragon_a')]: {
      probability: 0.4,
      preAffine: {
        a: 0.8,
        b: 0.1,
        c: 0,
        d: 0,
        e: -0.1,
        f: 0.8,
        g: 0,
        h: 0.1,
        i: 0,
        j: 0,
        k: 0.8,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.4, y: 0.5 },
      colorSpeed: 0.5,
      variations: {
        [vid('3d_dragon_a_v0')]: { type: 'heart3D', weight: 0.7 },
        [vid('3d_dragon_a_v1')]: { type: 'spiral3D', weight: 0.5 },
      },
    },
    [tid('3d_dragon_b')]: {
      probability: 0.3,
      preAffine: {
        a: 0.7,
        b: 0,
        c: 0.15,
        d: 0,
        e: 0,
        f: 0.7,
        g: 0,
        h: 0,
        i: -0.15,
        j: 0,
        k: 0.7,
        l: 0.1,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.2, y: 0.3 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_dragon_b_v0')]: { type: 'exponential3D', weight: 0.6 },
        [vid('3d_dragon_b_v1')]: { type: 'swirl3D', weight: 0.4 },
      },
    },
    [tid('3d_dragon_c')]: {
      probability: 0.3,
      preAffine: {
        a: 0.6,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.6,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.6,
        l: 0,
      },
      postAffine: {
        a: 0,
        b: -1,
        c: 0,
        d: 0,
        e: 1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.1, y: 0.6 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_dragon_c_v0')]: { type: 'julia3D', weight: 0.8 },
        [vid('3d_dragon_c_v1')]: { type: 'linear3D', weight: 0.3 },
      },
    },
  },
})
